// @flow

import dynamic from 'next/dynamic';

import { ICONS } from 'Components/utils/icon/icons';

const loaders = {
  'access-age': dynamic(() =>
    import('Components/widgets/icons/AccessAge.jsx').then(mod => mod.AccessAge),
  ),
  adventure: dynamic(() =>
    import('Components/widgets/icons/Adventure.jsx').then(mod => mod.Adventure),
  ),
  'beginner-sportive': dynamic(() =>
    import('Components/widgets/icons/BeginnerSportive.jsx').then(mod => mod.BeginnerSportive),
  ),
  couple: dynamic(() => import('Components/widgets/icons/Couple.jsx').then(mod => mod.Couple)),
  'culture-discovery': dynamic(() =>
    import('Components/widgets/icons/CultureDiscovery.jsx').then(mod => mod.CultureDiscovery),
  ),
  family: dynamic(() => import('Components/widgets/icons/Family.jsx').then(mod => mod.Family)),
  ClubMedGreatMemberFeedBack: dynamic(() =>
    import('Components/widgets/icons/ClubMedGreatMemberFeedBack.jsx').then(
      mod => mod.ClubMedGreatMemberFeedBack,
    ),
  ),
  ac: dynamic(() => import('Components/widgets/icons/Ac.jsx').then(mod => mod.Ac)),
  accessiblebathroom: dynamic(() =>
    import('Components/widgets/icons/Accessiblebathroom.jsx').then(mod => mod.Accessiblebathroom),
  ),
  accommodations: dynamic(() =>
    import('Components/widgets/icons/Accommodations.jsx').then(mod => mod.Accommodations),
  ),
  activities: dynamic(() =>
    import('Components/widgets/icons/Activities.jsx').then(mod => mod.Activities),
  ),
  address: dynamic(() => import('Components/widgets/icons/Address.jsx').then(mod => mod.Address)),

  advanced_skiing: dynamic(() =>
    import('Components/widgets/icons/AdvancedSkiing.jsx').then(mod => mod.AdvancedSkiing),
  ),
  aexc: dynamic(() => import('Components/widgets/icons/Aexc.jsx').then(mod => mod.Aexc)),

  agac: dynamic(() => import('Components/widgets/icons/Agac.jsx').then(mod => mod.Agac)),

  ahsc: dynamic(() => import('Components/widgets/icons/Ahsc.jsx').then(mod => mod.Ahsc)),

  albc: dynamic(() => import('Components/widgets/icons/Albc.jsx').then(mod => mod.Albc)),

  albv: dynamic(() => import('Components/widgets/icons/Albv.jsx').then(mod => mod.Albv)),

  alhc: dynamic(() => import('Components/widgets/icons/Alhc.jsx').then(mod => mod.Alhc)),

  allInclusive: dynamic(() =>
    import('Components/widgets/icons/AllInclusive.jsx').then(mod => mod.AllInclusive),
  ),
  amenities: dynamic(() =>
    import('Components/widgets/icons/Amenities.jsx').then(mod => mod.Amenities),
  ),
  amenities_laundry: dynamic(() =>
    import('Components/widgets/icons/AmenitiesLaundry.jsx').then(mod => mod.AmenitiesLaundry),
  ),
  americanfridge: dynamic(() =>
    import('Components/widgets/icons/Americanfridge.jsx').then(mod => mod.Americanfridge),
  ),
  anjj: dynamic(() => import('Components/widgets/icons/Anjj.jsx').then(mod => mod.Anjj)),

  answers: dynamic(() => import('Components/widgets/icons/Answers.jsx').then(mod => mod.Answers)),

  aplc: dynamic(() => import('Components/widgets/icons/Aplc.jsx').then(mod => mod.Aplc)),
  app: dynamic(() => import('Components/widgets/icons/App.jsx').then(mod => mod.App)),

  apres_ski: dynamic(() =>
    import('Components/widgets/icons/ApresSki.jsx').then(mod => mod.ApresSki),
  ),
  archery: dynamic(() => import('Components/widgets/icons/Archery.jsx').then(mod => mod.Archery)),

  arpc: dynamic(() => import('Components/widgets/icons/Arpc.jsx').then(mod => mod.Arpc)),

  arrowForth: dynamic(() =>
    import('Components/widgets/icons/ArrowForth.jsx').then(mod => mod.ArrowForth),
  ),
  arrowWithShadow: dynamic(() =>
    import('Components/widgets/icons/ArrowWithShadow.jsx').then(mod => mod.ArrowWithShadow),
  ),

  arrowWithTrail: dynamic(() =>
    import('Components/widgets/icons/ArrowWithTrail.jsx').then(mod => mod.ArrowWithTrail),
  ),
  avoc: dynamic(() => import('Components/widgets/icons/Avoc.jsx').then(mod => mod.Avoc)),

  'baby-bed': dynamic(() =>
    import('Components/widgets/icons/BabyBed.jsx').then(mod => mod.BabyBed),
  ),

  'baby-welcome': dynamic(() =>
    import('Components/widgets/icons/BabyWelcome.jsx').then(mod => mod.BabyWelcome),
  ),

  babyBottleHeater: dynamic(() =>
    import('Components/widgets/icons/BabyBottleHeater.jsx').then(mod => mod.BabyBottleHeater),
  ),

  babyClub: dynamic(() =>
    import('Components/widgets/icons/BabyClub.jsx').then(mod => mod.BabyClub),
  ),

  babyPowder: dynamic(() =>
    import('Components/widgets/icons/BabyPowder.jsx').then(mod => mod.BabyPowder),
  ),

  babySitting: dynamic(() =>
    import('Components/widgets/icons/BabySitting.jsx').then(mod => mod.BabySitting),
  ),

  badminton: dynamic(() =>
    import('Components/widgets/icons/Badminton.jsx').then(mod => mod.Badminton),
  ),

  baggage: dynamic(() => import('Components/widgets/icons/Baggage.jsx').then(mod => mod.Baggage)),

  balc: dynamic(() => import('Components/widgets/icons/Balc.jsx').then(mod => mod.Balc)),

  balcony: dynamic(() => import('Components/widgets/icons/Balcony.jsx').then(mod => mod.Balcony)),

  baldaquin: dynamic(() =>
    import('Components/widgets/icons/Baldaquin.jsx').then(mod => mod.Baldaquin),
  ),

  barcode: dynamic(() => import('Components/widgets/icons/Barcode.jsx').then(mod => mod.Barcode)),

  barsAndRestaurants: dynamic(() =>
    import('Components/widgets/icons/BarsAndRestaurants.jsx').then(mod => mod.BarsAndRestaurants),
  ),

  basketball: dynamic(() =>
    import('Components/widgets/icons/Basketball.jsx').then(mod => mod.Basketball),
  ),

  bathrobe: dynamic(() =>
    import('Components/widgets/icons/Bathrobe.jsx').then(mod => mod.Bathrobe),
  ),

  bathroom: dynamic(() =>
    import('Components/widgets/icons/Bathroom.jsx').then(mod => mod.Bathroom),
  ),

  bathtub: dynamic(() => import('Components/widgets/icons/Bathtub.jsx').then(mod => mod.Bathtub)),

  bathtubshower: dynamic(() =>
    import('Components/widgets/icons/Bathtubshower.jsx').then(mod => mod.Bathtubshower),
  ),

  bathtubtoilets: dynamic(() =>
    import('Components/widgets/icons/Bathtubtoilets.jsx').then(mod => mod.Bathtubtoilets),
  ),

  beach: dynamic(() => import('Components/widgets/icons/Beach.jsx').then(mod => mod.Beach)),

  beachtowel: dynamic(() =>
    import('Components/widgets/icons/Beachtowel.jsx').then(mod => mod.Beachtowel),
  ),

  'beauty-mirror': dynamic(() =>
    import('Components/widgets/icons/BeautyMirror.jsx').then(mod => mod.BeautyMirror),
  ),
  bednight: dynamic(() =>
    import('Components/widgets/icons/Bednight.jsx').then(mod => mod.Bednight),
  ),

  beic: dynamic(() => import('Components/widgets/icons/Beic.jsx').then(mod => mod.Beic)),

  bench: dynamic(() => import('Components/widgets/icons/Bench.jsx').then(mod => mod.Bench)),

  bib: dynamic(() => import('Components/widgets/icons/Bib.jsx').then(mod => mod.Bib)),

  bikeRental: dynamic(() =>
    import('Components/widgets/icons/BikeRental.jsx').then(mod => mod.BikeRental),
  ),

  biscuit: dynamic(() => import('Components/widgets/icons/Biscuit.jsx').then(mod => mod.Biscuit)),

  blender: dynamic(() => import('Components/widgets/icons/Blender.jsx').then(mod => mod.Blender)),

  bluetooth: dynamic(() =>
    import('Components/widgets/icons/Bluetooth.jsx').then(mod => mod.Bluetooth),
  ),

  bluetoothspeaker: dynamic(() =>
    import('Components/widgets/icons/Bluetoothspeaker.jsx').then(mod => mod.Bluetoothspeaker),
  ),
  boat: dynamic(() => import('Components/widgets/icons/Boat.jsx').then(mod => mod.Boat)),

  bodc: dynamic(() => import('Components/widgets/icons/Bodc.jsx').then(mod => mod.Bodc)),

  bolderArrowForth: dynamic(() =>
    import('Components/widgets/icons/BolderArrowForth.jsx').then(mod => mod.BolderArrowForth),
  ),

  bolderArrowForthDown: dynamic(() =>
    import('Components/widgets/icons/BolderArrowForthDown.jsx').then(
      mod => mod.BolderArrowForthDown,
    ),
  ),

  bolderArrowForthLeft: dynamic(() =>
    import('Components/widgets/icons/BolderArrowForthLeft.jsx').then(
      mod => mod.BolderArrowForthLeft,
    ),
  ),

  bolderArrowForthWithTail: dynamic(() =>
    import('Components/widgets/icons/BolderArrowForthWithTail.jsx').then(
      mod => mod.BolderArrowForthWithTail,
    ),
  ),

  bottleBrush: dynamic(() =>
    import('Components/widgets/icons/BottleBrush.jsx').then(mod => mod.BottleBrush),
  ),

  boutique: dynamic(() =>
    import('Components/widgets/icons/Boutique.jsx').then(mod => mod.Boutique),
  ),

  bowls: dynamic(() => import('Components/widgets/icons/Bowls.jsx').then(mod => mod.Bowls)),

  bucc: dynamic(() => import('Components/widgets/icons/Bucc.jsx').then(mod => mod.Bucc)),

  businessClass: dynamic(() =>
    import('Components/widgets/icons/BusinessClass.jsx').then(mod => mod.BusinessClass),
  ),

  canc: dynamic(() => import('Components/widgets/icons/Canc.jsx').then(mod => mod.Canc)),

  car: dynamic(() => import('Components/widgets/icons/Car.jsx').then(mod => mod.Car)),

  carc: dynamic(() => import('Components/widgets/icons/Carc.jsx').then(mod => mod.Carc)),

  cardioTraining: dynamic(() =>
    import('Components/widgets/icons/CardioTraining.jsx').then(mod => mod.CardioTraining),
  ),

  carpark: dynamic(() => import('Components/widgets/icons/Carpark.jsx').then(mod => mod.Carpark)),

  cd: dynamic(() => import('Components/widgets/icons/Cd.jsx').then(mod => mod.Cd)),

  cddvd: dynamic(() => import('Components/widgets/icons/Cddvd.jsx').then(mod => mod.Cddvd)),

  cerc: dynamic(() => import('Components/widgets/icons/Cerc.jsx').then(mod => mod.Cerc)),

  cfac: dynamic(() => import('Components/widgets/icons/Cfac.jsx').then(mod => mod.Cfac)),

  cgbj: dynamic(() => import('Components/widgets/icons/Cgbj.jsx').then(mod => mod.Cgbj)),

  chac: dynamic(() => import('Components/widgets/icons/Chac.jsx').then(mod => mod.Chac)),

  chairlifts: dynamic(() =>
    import('Components/widgets/icons/Chairlifts.jsx').then(mod => mod.Chairlifts),
  ),

  champagne: dynamic(() =>
    import('Components/widgets/icons/Champagne.jsx').then(mod => mod.Champagne),
  ),

  champagneglass: dynamic(() =>
    import('Components/widgets/icons/Champagneglass.jsx').then(mod => mod.Champagneglass),
  ),

  changingMat: dynamic(() =>
    import('Components/widgets/icons/ChangingMat.jsx').then(mod => mod.ChangingMat),
  ),

  chec: dynamic(() => import('Components/widgets/icons/Chec.jsx').then(mod => mod.Chec)),

  check: dynamic(() => import('Components/widgets/icons/Check.jsx').then(mod => mod.Check)),

  checkboxChecked: dynamic(() =>
    import('Components/widgets/icons/CheckboxChecked.jsx').then(mod => mod.CheckboxChecked),
  ),

  checkboxUnchecked: dynamic(() =>
    import('Components/widgets/icons/CheckboxUnchecked.jsx').then(mod => mod.CheckboxUnchecked),
  ),

  childcare: dynamic(() =>
    import('Components/widgets/icons/Childcare.jsx').then(mod => mod.Childcare),
  ),

  children: dynamic(() =>
    import('Components/widgets/icons/Children.jsx').then(mod => mod.Children),
  ),

  chrono: dynamic(() => import('Components/widgets/icons/Chrono.jsx').then(mod => mod.Chrono)),

  circledAccommodation: dynamic(() =>
    import('Components/widgets/icons/CircledAccommodation.jsx').then(
      mod => mod.CircledAccommodation,
    ),
  ),

  circledCross: dynamic(() =>
    import('Components/widgets/icons/CircledCross.jsx').then(mod => mod.CircledCross),
  ),

  circledPlane: dynamic(() =>
    import('Components/widgets/icons/CircledPlane.jsx').then(mod => mod.CircledPlane),
  ),

  tour: dynamic(() => import('Components/widgets/icons/Tour.jsx').then(mod => mod.Tour)),

  climbing: dynamic(() =>
    import('Components/widgets/icons/Climbing.jsx').then(mod => mod.Climbing),
  ),

  closedEyePassword: dynamic(() =>
    import('Components/widgets/icons/ClosedEyePassword.jsx').then(mod => mod.ClosedEyePassword),
  ),

  clubMedGreatMembersIntro: dynamic(() =>
    import('Components/widgets/icons/ClubMedGreatMembersIntro.jsx').then(
      mod => mod.ClubMedGreatMembersIntro,
    ),
  ),

  clubmed: dynamic(() => import('Components/widgets/icons/Clubmed.jsx').then(mod => mod.Clubmed)),

  clubmedAllInclusiveLarge: dynamic(() =>
    import('Components/widgets/icons/ClubmedAllInclusiveLarge.jsx').then(
      mod => mod.ClubmedAllInclusiveLarge,
    ),
  ),

  clubmedAllInclusiveSmall: dynamic(() =>
    import('Components/widgets/icons/ClubmedAllInclusiveSmall.jsx').then(
      mod => mod.ClubmedAllInclusiveSmall,
    ),
  ),

  clubmedGM: dynamic(() =>
    import('Components/widgets/icons/ClubmedGm.jsx').then(mod => mod.ClubmedGm),
  ),

  clubmedJobs: dynamic(() =>
    import('Components/widgets/icons/ClubmedJobs.jsx').then(mod => mod.ClubmedJobs),
  ),

  clubmedJoyView: dynamic(() =>
    import('Components/widgets/icons/ClubmedJoyView.jsx').then(mod => mod.ClubmedJoyView),
  ),

  clubmedMeetings: dynamic(() =>
    import('Components/widgets/icons/ClubmedMeetings.jsx').then(mod => mod.ClubmedMeetings),
  ),

  clubmedPlus: dynamic(() =>
    import('Components/widgets/icons/ClubmedPlus.jsx').then(mod => mod.ClubmedPlus),
  ),

  clubmedProperty: dynamic(() =>
    import('Components/widgets/icons/ClubmedProperty.jsx').then(mod => mod.ClubmedProperty),
  ),

  cm2c: dynamic(() => import('Components/widgets/icons/Cm2c.jsx').then(mod => mod.Cm2c)),

  cocoaPowder: dynamic(() =>
    import('Components/widgets/icons/CocoaPowder.jsx').then(mod => mod.CocoaPowder),
  ),

  coffeemaker: dynamic(() =>
    import('Components/widgets/icons/Coffeemaker.jsx').then(mod => mod.Coffeemaker),
  ),

  colc: dynamic(() => import('Components/widgets/icons/Colc.jsx').then(mod => mod.Colc)),

  compass: dynamic(() => import('Components/widgets/icons/Compass.jsx').then(mod => mod.Compass)),

  confirmation: dynamic(() =>
    import('Components/widgets/icons/Confirmation.jsx').then(mod => mod.Confirmation),
  ),

  connect: dynamic(() => import('Components/widgets/icons/Connect.jsx').then(mod => mod.Connect)),

  connecting: dynamic(() =>
    import('Components/widgets/icons/Connecting.jsx').then(mod => mod.Connecting),
  ),

  'connection-information': dynamic(() =>
    import('Components/widgets/icons/ConnectionInformation.jsx').then(
      mod => mod.ConnectionInformation,
    ),
  ),
  contact: dynamic(() => import('Components/widgets/icons/Contact.jsx').then(mod => mod.Contact)),

  creactive: dynamic(() =>
    import('Components/widgets/icons/Creactive.jsx').then(mod => mod.Creactive),
  ),

  creditcard: dynamic(() =>
    import('Components/widgets/icons/Creditcard.jsx').then(mod => mod.Creditcard),
  ),

  crgc: dynamic(() => import('Components/widgets/icons/Crgc.jsx').then(mod => mod.Crgc)),

  cross: dynamic(() => import('Components/widgets/icons/Cross.jsx').then(mod => mod.Cross)),

  cruise: dynamic(() => import('Components/widgets/icons/Cruise.jsx').then(mod => mod.Cruise)),

  cskc: dynamic(() => import('Components/widgets/icons/Cskc.jsx').then(mod => mod.Cskc)),

  dalc: dynamic(() => import('Components/widgets/icons/Dalc.jsx').then(mod => mod.Dalc)),

  dance: dynamic(() => import('Components/widgets/icons/Dance.jsx').then(mod => mod.Dance)),

  daoc: dynamic(() => import('Components/widgets/icons/Daoc.jsx').then(mod => mod.Daoc)),

  date: dynamic(() => import('Components/widgets/icons/Date.jsx').then(mod => mod.Date)),

  datePlus: dynamic(() =>
    import('Components/widgets/icons/DatePlus.jsx').then(mod => mod.DatePlus),
  ),

  dateStar: dynamic(() =>
    import('Components/widgets/icons/DateStar.jsx').then(mod => mod.DateStar),
  ),

  daybed: dynamic(() => import('Components/widgets/icons/Daybed.jsx').then(mod => mod.Daybed)),

  dbac: dynamic(() => import('Components/widgets/icons/Dbac.jsx').then(mod => mod.Dbac)),

  ddoc: dynamic(() => import('Components/widgets/icons/Ddoc.jsx').then(mod => mod.Ddoc)),

  dedicated: dynamic(() =>
    import('Components/widgets/icons/Dedicated.jsx').then(mod => mod.Dedicated),
  ),

  destination: dynamic(() =>
    import('Components/widgets/icons/Destination.jsx').then(mod => mod.Destination),
  ),

  details: dynamic(() => import('Components/widgets/icons/Details.jsx').then(mod => mod.Details)),

  digital_EC: dynamic(() =>
    import('Components/widgets/icons/DigitalEC.jsx').then(mod => mod.DigitalEC),
  ),

  disconnection: dynamic(() =>
    import('Components/widgets/icons/Disconnection.jsx').then(mod => mod.Disconnection),
  ),

  'discovery-center': dynamic(() =>
    import('Components/widgets/icons/DiscoveryCenter.jsx').then(mod => mod.DiscoveryCenter),
  ),
  dishes: dynamic(() => import('Components/widgets/icons/Dishes.jsx').then(mod => mod.Dishes)),

  dishwasher: dynamic(() =>
    import('Components/widgets/icons/Dishwasher.jsx').then(mod => mod.Dishwasher),
  ),

  disinfection: dynamic(() =>
    import('Components/widgets/icons/Disinfection.jsx').then(mod => mod.Disinfection),
  ),

  disposableSilverware: dynamic(() =>
    import('Components/widgets/icons/DisposableSilverware.jsx').then(
      mod => mod.DisposableSilverware,
    ),
  ),
  distancing: dynamic(() =>
    import('Components/widgets/icons/Distancing.jsx').then(mod => mod.Distancing),
  ),

  diving: dynamic(() => import('Components/widgets/icons/Diving.jsx').then(mod => mod.Diving)),

  dmd_club: dynamic(() => import('Components/widgets/icons/DmdClub.jsx').then(mod => mod.DmdClub)),
  dmd_deluxe: dynamic(() =>
    import('Components/widgets/icons/DmdDeluxe.jsx').then(mod => mod.DmdDeluxe),
  ),
  dmd_suite: dynamic(() =>
    import('Components/widgets/icons/DmdSuite.jsx').then(mod => mod.DmdSuite),
  ),
  dmd_superior: dynamic(() =>
    import('Components/widgets/icons/DmdSuperior.jsx').then(mod => mod.DmdSuperior),
  ),
  document: dynamic(() =>
    import('Components/widgets/icons/Document.jsx').then(mod => mod.Document),
  ),
  documentColored: dynamic(() =>
    import('Components/widgets/icons/DocumentColored.jsx').then(mod => mod.DocumentColored),
  ),

  donation: dynamic(() =>
    import('Components/widgets/icons/Donation.jsx').then(mod => mod.Donation),
  ),

  doorhanger: dynamic(() =>
    import('Components/widgets/icons/Doorhanger.jsx').then(mod => mod.Doorhanger),
  ),

  'double-balcony': dynamic(() =>
    import('Components/widgets/icons/DoubleBalcony.jsx').then(mod => mod.DoubleBalcony),
  ),
  download: dynamic(() =>
    import('Components/widgets/icons/Download.jsx').then(mod => mod.Download),
  ),
  doctor: dynamic(() => import('Components/widgets/icons/Doctor.jsx').then(mod => mod.Doctor)),

  dresscode: dynamic(() =>
    import('Components/widgets/icons/Dresscode.jsx').then(mod => mod.Dresscode),
  ),

  dressing: dynamic(() =>
    import('Components/widgets/icons/Dressing.jsx').then(mod => mod.Dressing),
  ),
  dressingtable: dynamic(() =>
    import('Components/widgets/icons/Dressingtable.jsx').then(mod => mod.Dressingtable),
  ),

  dryer: dynamic(() => import('Components/widgets/icons/Dryer.jsx').then(mod => mod.Dryer)),

  dualbathroom: dynamic(() =>
    import('Components/widgets/icons/Dualbathroom.jsx').then(mod => mod.Dualbathroom),
  ),

  dualcabin: dynamic(() =>
    import('Components/widgets/icons/Dualcabin.jsx').then(mod => mod.Dualcabin),
  ),

  duration: dynamic(() =>
    import('Components/widgets/icons/Duration.jsx').then(mod => mod.Duration),
  ),

  dvd: dynamic(() => import('Components/widgets/icons/Dvd.jsx').then(mod => mod.Dvd)),

  earth: dynamic(() => import('Components/widgets/icons/Earth.jsx').then(mod => mod.Earth)),

  earthPlane: dynamic(() =>
    import('Components/widgets/icons/EarthPlane.jsx').then(mod => mod.EarthPlane),
  ),

  easyArrivalTitle: dynamic(() =>
    import('Components/widgets/icons/EasyArrivalTitle.jsx').then(mod => mod.EasyArrivalTitle),
  ),

  electricity: dynamic(() =>
    import('Components/widgets/icons/Electricity.jsx').then(mod => mod.Electricity),
  ),

  entertainment: dynamic(() =>
    import('Components/widgets/icons/Entertainment.jsx').then(mod => mod.Entertainment),
  ),

  espresso: dynamic(() =>
    import('Components/widgets/icons/Espresso.jsx').then(mod => mod.Espresso),
  ),

  exclusiveCollection: dynamic(() =>
    import('Components/widgets/icons/ExclusiveCollection.jsx').then(mod => mod.ExclusiveCollection),
  ),

  eyePassword: dynamic(() =>
    import('Components/widgets/icons/EyePassword.jsx').then(mod => mod.EyePassword),
  ),

  facebook: dynamic(() =>
    import('Components/widgets/icons/Facebook.jsx').then(mod => mod.Facebook),
  ),

  twitter: dynamic(() => import('Components/widgets/icons/Twitter.jsx').then(mod => mod.Twitter)),

  pinterest: dynamic(() =>
    import('Components/widgets/icons/Pinterest.jsx').then(mod => mod.Pinterest),
  ),

  fan: dynamic(() => import('Components/widgets/icons/Fan.jsx').then(mod => mod.Fan)),

  fatDot: dynamic(() => import('Components/widgets/icons/FatDot.jsx').then(mod => mod.FatDot)),

  'fir-tree-view': dynamic(() =>
    import('Components/widgets/icons/FirTreeView.jsx').then(mod => mod.FirTreeView),
  ),
  fireplace: dynamic(() =>
    import('Components/widgets/icons/FirePlace.jsx').then(mod => mod.FirePlace),
  ),

  fitness: dynamic(() => import('Components/widgets/icons/Fitness.jsx').then(mod => mod.Fitness)),

  flexible: dynamic(() =>
    import('Components/widgets/icons/Flexible.jsx').then(mod => mod.Flexible),
  ),

  folder: dynamic(() => import('Components/widgets/icons/Folder.jsx').then(mod => mod.Folder)),

  football: dynamic(() =>
    import('Components/widgets/icons/Football.jsx').then(mod => mod.Football),
  ),

  fridge: dynamic(() => import('Components/widgets/icons/Fridge.jsx').then(mod => mod.Fridge)),

  fruitBasket: dynamic(() =>
    import('Components/widgets/icons/FruitBasket.jsx').then(mod => mod.FruitBasket),
  ),

  fruitJuice: dynamic(() =>
    import('Components/widgets/icons/FruitJuice.jsx').then(mod => mod.FruitJuice),
  ),

  'furnished-terrace': dynamic(() =>
    import('Components/widgets/icons/FurnishedTerrace.jsx').then(mod => mod.FurnishedTerrace),
  ),
  garden_side: dynamic(() =>
    import('Components/widgets/icons/GardenSide.jsx').then(mod => mod.GardenSide),
  ),

  garden_view: dynamic(() =>
    import('Components/widgets/icons/GardenView.jsx').then(mod => mod.GardenView),
  ),

  gloves: dynamic(() => import('Components/widgets/icons/Gloves.jsx').then(mod => mod.Gloves)),

  gmac: dynamic(() => import('Components/widgets/icons/Gmac.jsx').then(mod => mod.Gmac)),

  gmav: dynamic(() => import('Components/widgets/icons/Gmav.jsx').then(mod => mod.Gmav)),

  'golf-view': dynamic(() =>
    import('Components/widgets/icons/GolfView.jsx').then(mod => mod.GolfView),
  ),
  golf: dynamic(() => import('Components/widgets/icons/Golf.jsx').then(mod => mod.Golf)),

  greatCheck: dynamic(() =>
    import('Components/widgets/icons/GreatCheck.jsx').then(mod => mod.GreatCheck),
  ),

  grec: dynamic(() => import('Components/widgets/icons/Grec.jsx').then(mod => mod.Grec)),

  grounds: dynamic(() => import('Components/widgets/icons/Grounds.jsx').then(mod => mod.Grounds)),

  grwj: dynamic(() => import('Components/widgets/icons/Grwj.jsx').then(mod => mod.Grwj)),

  guic: dynamic(() => import('Components/widgets/icons/Guic.jsx').then(mod => mod.Guic)),

  handsShake: dynamic(() =>
    import('Components/widgets/icons/HandsShake.jsx').then(mod => mod.HandsShake),
  ),

  hairdresser: dynamic(() =>
    import('Components/widgets/icons/Hairdresser.jsx').then(mod => mod.Hairdresser),
  ),

  hairdryer: dynamic(() =>
    import('Components/widgets/icons/Hairdryer.jsx').then(mod => mod.Hairdryer),
  ),
  hamburger: dynamic(() =>
    import('Components/widgets/icons/Hamburger.jsx').then(mod => mod.Hamburger),
  ),

  hammam: dynamic(() => import('Components/widgets/icons/Hammam.jsx').then(mod => mod.Hammam)),

  happyArrival: dynamic(() =>
    import('Components/widgets/icons/HappyArrival.jsx').then(mod => mod.HappyArrival),
  ),

  happyFirst: dynamic(() =>
    import('Components/widgets/icons/HappyFirst.jsx').then(mod => mod.HappyFirst),
  ),

  health: dynamic(() => import('Components/widgets/icons/Health.jsx').then(mod => mod.Health)),

  heart: dynamic(() => import('Components/widgets/icons/Heart.jsx').then(mod => mod.Heart)),

  heartFilled: dynamic(() =>
    import('Components/widgets/icons/HeartFilled.jsx').then(mod => mod.HeartFilled),
  ),

  home: dynamic(() => import('Components/widgets/icons/Home.jsx').then(mod => mod.Home)),

  homecinema: dynamic(() =>
    import('Components/widgets/icons/Homecinema.jsx').then(mod => mod.Homecinema),
  ),

  household: dynamic(() =>
    import('Components/widgets/icons/Household.jsx').then(mod => mod.Household),
  ),

  icebucket: dynamic(() =>
    import('Components/widgets/icons/Icebucket.jsx').then(mod => mod.Icebucket),
  ),

  icemaker: dynamic(() =>
    import('Components/widgets/icons/Icemaker.jsx').then(mod => mod.Icemaker),
  ),

  idealForFamily: dynamic(() =>
    import('Components/widgets/icons/IdealForFamily.jsx').then(mod => mod.IdealForFamily),
  ),

  induction: dynamic(() =>
    import('Components/widgets/icons/Induction.jsx').then(mod => mod.Induction),
  ),

  information: dynamic(() =>
    import('Components/widgets/icons/Information.jsx').then(mod => mod.Information),
  ),

  informationFilled: dynamic(() =>
    import('Components/widgets/icons/InformationFilled.jsx').then(mod => mod.InformationFilled),
  ),

  instagram: dynamic(() =>
    import('Components/widgets/icons/Instagram.jsx').then(mod => mod.Instagram),
  ),

  insurance: dynamic(() =>
    import('Components/widgets/icons/Insurance.jsx').then(mod => mod.Insurance),
  ),

  internet: dynamic(() =>
    import('Components/widgets/icons/Internet.jsx').then(mod => mod.Internet),
  ),

  ipoddock: dynamic(() =>
    import('Components/widgets/icons/Ipoddock.jsx').then(mod => mod.Ipoddock),
  ),

  ironing: dynamic(() => import('Components/widgets/icons/Ironing.jsx').then(mod => mod.Ironing)),

  itac: dynamic(() => import('Components/widgets/icons/Itac.jsx').then(mod => mod.Itac)),

  ixtc: dynamic(() => import('Components/widgets/icons/Ixtc.jsx').then(mod => mod.Ixtc)),

  juicer: dynamic(() => import('Components/widgets/icons/Juicer.jsx').then(mod => mod.Juicer)),

  junior: dynamic(() => import('Components/widgets/icons/Junior.jsx').then(mod => mod.Junior)),

  kabc: dynamic(() => import('Components/widgets/icons/Kabc.jsx').then(mod => mod.Kabc)),

  kahc: dynamic(() => import('Components/widgets/icons/Kahc.jsx').then(mod => mod.Kahc)),

  kamc: dynamic(() => import('Components/widgets/icons/Kamc.jsx').then(mod => mod.Kamc)),

  kanc: dynamic(() => import('Components/widgets/icons/Kanc.jsx').then(mod => mod.Kanc)),

  kanv: dynamic(() => import('Components/widgets/icons/Kanv.jsx').then(mod => mod.Kanv)),

  kayak: dynamic(() => import('Components/widgets/icons/Kayak.jsx').then(mod => mod.Kayak)),

  kemc: dynamic(() => import('Components/widgets/icons/Kemc.jsx').then(mod => mod.Kemc)),

  kettle: dynamic(() => import('Components/widgets/icons/Kettle.jsx').then(mod => mod.Kettle)),

  keys: dynamic(() => import('Components/widgets/icons/Keys.jsx').then(mod => mod.Keys)),

  'kids-sleeping-area': dynamic(() =>
    import('Components/widgets/icons/KidsSleepingArea.jsx').then(mod => mod.KidsSleepingArea),
  ),
  kitchen: dynamic(() => import('Components/widgets/icons/Kitchen.jsx').then(mod => mod.Kitchen)),

  kitchenstorage: dynamic(() =>
    import('Components/widgets/icons/Kitchenstorage.jsx').then(mod => mod.Kitchenstorage),
  ),

  kitchenware: dynamic(() =>
    import('Components/widgets/icons/Kitchenware.jsx').then(mod => mod.Kitchenware),
  ),

  kitesurf: dynamic(() =>
    import('Components/widgets/icons/Kitesurf.jsx').then(mod => mod.Kitesurf),
  ),

  lakeside: dynamic(() =>
    import('Components/widgets/icons/Lakeside.jsx').then(mod => mod.Lakeside),
  ),

  lapc: dynamic(() => import('Components/widgets/icons/Lapc.jsx').then(mod => mod.Lapc)),

  laundry: dynamic(() => import('Components/widgets/icons/Laundry.jsx').then(mod => mod.Laundry)),

  leftArrow: dynamic(() =>
    import('Components/widgets/icons/LeftArrow.jsx').then(mod => mod.LeftArrow),
  ),

  leisure_and_relaxation: dynamic(() =>
    import('Components/widgets/icons/LeisureAndRelaxation.jsx').then(
      mod => mod.LeisureAndRelaxation,
    ),
  ),

  level: dynamic(() => import('Components/widgets/icons/Level.jsx').then(mod => mod.Level)),

  lightbulb: dynamic(() =>
    import('Components/widgets/icons/Lightbulb.jsx').then(mod => mod.Lightbulb),
  ),

  lotion: dynamic(() => import('Components/widgets/icons/Lotion.jsx').then(mod => mod.Lotion)),

  'lounge-area': dynamic(() =>
    import('Components/widgets/icons/LoungeArea.jsx').then(mod => mod.LoungeArea),
  ),
  lpac: dynamic(() => import('Components/widgets/icons/Lpac.jsx').then(mod => mod.Lpac)),

  lroc: dynamic(() => import('Components/widgets/icons/Lroc.jsx').then(mod => mod.Lroc)),

  luggage: dynamic(() => import('Components/widgets/icons/Luggage.jsx').then(mod => mod.Luggage)),

  lunch: dynamic(() => import('Components/widgets/icons/Lunch.jsx').then(mod => mod.Lunch)),

  magnifyingGlass: dynamic(() =>
    import('Components/widgets/icons/MagnifyingGlass.jsx').then(mod => mod.MagnifyingGlass),
  ),

  mail: dynamic(() => import('Components/widgets/icons/Mail.jsx').then(mod => mod.Mail)),

  manage: dynamic(() => import('Components/widgets/icons/Manage.jsx').then(mod => mod.Manage)),

  manc: dynamic(() => import('Components/widgets/icons/Manc.jsx').then(mod => mod.Manc)),

  manualJuicer: dynamic(() =>
    import('Components/widgets/icons/ManualJuicer.jsx').then(mod => mod.ManualJuicer),
  ),

  map_minus: dynamic(() =>
    import('Components/widgets/icons/MapMinus.jsx').then(mod => mod.MapMinus),
  ),

  map_plus: dynamic(() => import('Components/widgets/icons/MapPlus.jsx').then(mod => mod.MapPlus)),

  map_rotate_left: dynamic(() =>
    import('Components/widgets/icons/MapRotateLeft.jsx').then(mod => mod.MapRotateLeft),
  ),

  map_rotate_right: dynamic(() =>
    import('Components/widgets/icons/MapRotateRight.jsx').then(mod => mod.MapRotateRight),
  ),

  mask: dynamic(() => import('Components/widgets/icons/Mask.jsx').then(mod => mod.Mask)),

  mauc: dynamic(() => import('Components/widgets/icons/Mauc.jsx').then(mod => mod.Mauc)),

  maximize: dynamic(() =>
    import('Components/widgets/icons/Maximize.jsx').then(mod => mod.Maximize),
  ),

  mchc: dynamic(() => import('Components/widgets/icons/Mchc.jsx').then(mod => mod.Mchc)),

  meetingsevents: dynamic(() =>
    import('Components/widgets/icons/Meetingsevents.jsx').then(mod => mod.Meetingsevents),
  ),

  microwave: dynamic(() =>
    import('Components/widgets/icons/Microwave.jsx').then(mod => mod.Microwave),
  ),

  microwaveDishes: dynamic(() =>
    import('Components/widgets/icons/MicrowaveDishes.jsx').then(mod => mod.MicrowaveDishes),
  ),

  miniClub: dynamic(() =>
    import('Components/widgets/icons/MiniClub.jsx').then(mod => mod.MiniClub),
  ),

  minifridge: dynamic(() =>
    import('Components/widgets/icons/Minifridge.jsx').then(mod => mod.Minifridge),
  ),

  minimize: dynamic(() =>
    import('Components/widgets/icons/Minimize.jsx').then(mod => mod.Minimize),
  ),

  minus: dynamic(() => import('Components/widgets/icons/Minus.jsx').then(mod => mod.Minus)),

  mmac: dynamic(() => import('Components/widgets/icons/Mmac.jsx').then(mod => mod.Mmac)),

  mobile: dynamic(() => import('Components/widgets/icons/Mobile.jsx').then(mod => mod.Mobile)),

  mosquitos: dynamic(() =>
    import('Components/widgets/icons/Mosquitos.jsx').then(mod => mod.Mosquitos),
  ),

  'mountain-diner': dynamic(() =>
    import('Components/widgets/icons/MountainDiner.jsx').then(mod => mod.MountainDiner),
  ),
  'mountain-view': dynamic(() =>
    import('Components/widgets/icons/MountainView.jsx').then(mod => mod.MountainView),
  ),
  mpac: dynamic(() => import('Components/widgets/icons/Mpac.jsx').then(mod => mod.Mpac)),

  mpec: dynamic(() => import('Components/widgets/icons/Mpec.jsx').then(mod => mod.Mpec)),

  musculation: dynamic(() =>
    import('Components/widgets/icons/Musculation.jsx').then(mod => mod.Musculation),
  ),

  musicclock: dynamic(() =>
    import('Components/widgets/icons/Musicclock.jsx').then(mod => mod.Musicclock),
  ),

  'mustTryExperiences-fr': dynamic(() =>
    import('Components/widgets/icons/MustTryExperiencesFr.jsx').then(
      mod => mod.MustTryExperiencesFr,
    ),
  ),
  mustTryExperiences: dynamic(() =>
    import('Components/widgets/icons/MustTryExperiences.jsx').then(mod => mod.MustTryExperiences),
  ),

  napc: dynamic(() => import('Components/widgets/icons/Napc.jsx').then(mod => mod.Napc)),

  nature: dynamic(() => import('Components/widgets/icons/Nature.jsx').then(mod => mod.Nature)),

  new: dynamic(() => import('Components/widgets/icons/New.jsx').then(mod => mod.New)),

  newsletter: dynamic(() =>
    import('Components/widgets/icons/Newsletter.jsx').then(mod => mod.Newsletter),
  ),

  noStop: dynamic(() => import('Components/widgets/icons/NoStop.jsx').then(mod => mod.NoStop)),

  noTransport: dynamic(() =>
    import('Components/widgets/icons/NoTransport.jsx').then(mod => mod.NoTransport),
  ),

  notebook: dynamic(() =>
    import('Components/widgets/icons/Notebook.jsx').then(mod => mod.Notebook),
  ),

  ofuro: dynamic(() => import('Components/widgets/icons/Ofuro.jsx').then(mod => mod.Ofuro)),

  oil: dynamic(() => import('Components/widgets/icons/Oil.jsx').then(mod => mod.Oil)),

  onDemand: dynamic(() =>
    import('Components/widgets/icons/OnDemand.jsx').then(mod => mod.OnDemand),
  ),

  opic: dynamic(() => import('Components/widgets/icons/Opic.jsx').then(mod => mod.Opic)),

  option: dynamic(() => import('Components/widgets/icons/Option.jsx').then(mod => mod.Option)),

  oven: dynamic(() => import('Components/widgets/icons/Oven.jsx').then(mod => mod.Oven)),

  padlock: dynamic(() => import('Components/widgets/icons/Padlock.jsx').then(mod => mod.Padlock)),

  pahc: dynamic(() => import('Components/widgets/icons/Pahc.jsx').then(mod => mod.Pahc)),

  pajamas: dynamic(() => import('Components/widgets/icons/Pajamas.jsx').then(mod => mod.Pajamas)),

  palc: dynamic(() => import('Components/widgets/icons/Palc.jsx').then(mod => mod.Palc)),

  paperDispenser: dynamic(() =>
    import('Components/widgets/icons/PaperDispenser.jsx').then(mod => mod.PaperDispenser),
  ),

  parking: dynamic(() => import('Components/widgets/icons/Parking.jsx').then(mod => mod.Parking)),

  passport: dynamic(() =>
    import('Components/widgets/icons/Passport.jsx').then(mod => mod.Passport),
  ),

  passworld: dynamic(() =>
    import('Components/widgets/icons/Passworld.jsx').then(mod => mod.Passworld),
  ),

  paymentPlan: dynamic(() =>
    import('Components/widgets/icons/PaymentPlan.jsx').then(mod => mod.PaymentPlan),
  ),

  pcac: dynamic(() => import('Components/widgets/icons/Pcac.jsx').then(mod => mod.Pcac)),

  pdf: dynamic(() => import('Components/widgets/icons/Pdf.jsx').then(mod => mod.Pdf)),

  pen: dynamic(() => import('Components/widgets/icons/Pen.jsx').then(mod => mod.Pen)),

  people: dynamic(() => import('Components/widgets/icons/People.jsx').then(mod => mod.People)),

  percentage: dynamic(() =>
    import('Components/widgets/icons/Percentage.jsx').then(mod => mod.Percentage),
  ),

  petanque: dynamic(() =>
    import('Components/widgets/icons/Petanque.jsx').then(mod => mod.Petanque),
  ),

  petitClub: dynamic(() =>
    import('Components/widgets/icons/PetitClub.jsx').then(mod => mod.PetitClub),
  ),

  phone: dynamic(() => import('Components/widgets/icons/Phone.jsx').then(mod => mod.Phone)),

  phoneBubble: dynamic(() =>
    import('Components/widgets/icons/PhoneBubble.jsx').then(mod => mod.PhoneBubble),
  ),

  photoAlbum: dynamic(() =>
    import('Components/widgets/icons/PhotoAlbum.jsx').then(mod => mod.PhotoAlbum),
  ),

  phuc: dynamic(() => import('Components/widgets/icons/Phuc.jsx').then(mod => mod.Phuc)),

  pin_amenity: dynamic(() =>
    import('Components/widgets/icons/PinAmenity.jsx').then(mod => mod.PinAmenity),
  ),

  pin_room: dynamic(() => import('Components/widgets/icons/PinRoom.jsx').then(mod => mod.PinRoom)),

  pin_room_highlight: dynamic(() =>
    import('Components/widgets/icons/PinRoomHighlight.jsx').then(mod => mod.PinRoomHighlight),
  ),

  plac: dynamic(() => import('Components/widgets/icons/Plac.jsx').then(mod => mod.Plac)),

  planeAndCircle: dynamic(() =>
    import('Components/widgets/icons/PlaneAndCircle.jsx').then(mod => mod.PlaneAndCircle),
  ),

  planeComfort: dynamic(() =>
    import('Components/widgets/icons/PlaneComfort.jsx').then(mod => mod.PlaneComfort),
  ),

  plates: dynamic(() => import('Components/widgets/icons/Plates.jsx').then(mod => mod.Plates)),

  plus: dynamic(() => import('Components/widgets/icons/Plus.jsx').then(mod => mod.Plus)),

  pmr: dynamic(() => import('Components/widgets/icons/Pmr.jsx').then(mod => mod.Pmr)),

  'pool-towels': dynamic(() =>
    import('Components/widgets/icons/PoolTowels.jsx').then(mod => mod.PoolTowels),
  ),
  'pool-view': dynamic(() =>
    import('Components/widgets/icons/PoolView.jsx').then(mod => mod.PoolView),
  ),
  poolside: dynamic(() =>
    import('Components/widgets/icons/Poolside.jsx').then(mod => mod.Poolside),
  ),

  potty: dynamic(() => import('Components/widgets/icons/Potty.jsx').then(mod => mod.Potty)),

  prac: dynamic(() => import('Components/widgets/icons/Prac.jsx').then(mod => mod.Prac)),

  pressing: dynamic(() =>
    import('Components/widgets/icons/Pressing.jsx').then(mod => mod.Pressing),
  ),
  priorityspa: dynamic(() =>
    import('Components/widgets/icons/Priorityspa.jsx').then(mod => mod.Priorityspa),
  ),

  'private-bathroom': dynamic(() =>
    import('Components/widgets/icons/PrivateBathroom.jsx').then(mod => mod.PrivateBathroom),
  ),
  'private-furnished-terrace': dynamic(() =>
    import('Components/widgets/icons/PrivateFurnishedTerrace.jsx').then(
      mod => mod.PrivateFurnishedTerrace,
    ),
  ),
  'private-garden': dynamic(() =>
    import('Components/widgets/icons/PrivateGarden.jsx').then(mod => mod.PrivateGarden),
  ),
  'private-pool': dynamic(() =>
    import('Components/widgets/icons/PrivatePool.jsx').then(mod => mod.PrivatePool),
  ),
  'private-ski': dynamic(() =>
    import('Components/widgets/icons/PrivateSki.jsx').then(mod => mod.PrivateSki),
  ),
  privateTransfer: dynamic(() =>
    import('Components/widgets/icons/PrivateTransfer.jsx').then(mod => mod.PrivateTransfer),
  ),

  promoCode: dynamic(() =>
    import('Components/widgets/icons/PromoCode.jsx').then(mod => mod.PromoCode),
  ),

  pvac: dynamic(() => import('Components/widgets/icons/Pvac.jsx').then(mod => mod.Pvac)),

  qchc: dynamic(() => import('Components/widgets/icons/Qchc.jsx').then(mod => mod.Qchc)),

  question: dynamic(() =>
    import('Components/widgets/icons/Question.jsx').then(mod => mod.Question),
  ),

  quotationMark: dynamic(() =>
    import('Components/widgets/icons/QuotationMark.jsx').then(mod => mod.QuotationMark),
  ),

  raclette: dynamic(() =>
    import('Components/widgets/icons/Raclette.jsx').then(mod => mod.Raclette),
  ),

  rainshower: dynamic(() =>
    import('Components/widgets/icons/Rainshower.jsx').then(mod => mod.Rainshower),
  ),

  rbic: dynamic(() => import('Components/widgets/icons/Rbic.jsx').then(mod => mod.Rbic)),

  rdpc: dynamic(() => import('Components/widgets/icons/Rdpc.jsx').then(mod => mod.Rdpc)),

  receipt: dynamic(() => import('Components/widgets/icons/Receipt.jsx').then(mod => mod.Receipt)),

  reception: dynamic(() =>
    import('Components/widgets/icons/Reception.jsx').then(mod => mod.Reception),
  ),
  receptionMask: dynamic(() =>
    import('Components/widgets/icons/ReceptionMask.jsx').then(mod => mod.ReceptionMask),
  ),

  'repartition-baby': dynamic(() =>
    import('Components/widgets/icons/RepartitionBaby.jsx').then(mod => mod.RepartitionBaby),
  ),
  reset: dynamic(() => import('Components/widgets/icons/Reset.jsx').then(mod => mod.Reset)),

  restaurant: dynamic(() =>
    import('Components/widgets/icons/Restaurant.jsx').then(mod => mod.Restaurant),
  ),
  restaurantMask: dynamic(() =>
    import('Components/widgets/icons/RestaurantMask.jsx').then(mod => mod.RestaurantMask),
  ),

  reverseClock: dynamic(() =>
    import('Components/widgets/icons/ReverseClock.jsx').then(mod => mod.ReverseClock),
  ),

  riding: dynamic(() => import('Components/widgets/icons/Riding.jsx').then(mod => mod.Riding)),

  'river-view': dynamic(() =>
    import('Components/widgets/icons/RiverView.jsx').then(mod => mod.RiverView),
  ),
  roller: dynamic(() => import('Components/widgets/icons/Roller.jsx').then(mod => mod.Roller)),

  'room-service': dynamic(() =>
    import('Components/widgets/icons/RoomService.jsx').then(mod => mod.RoomService),
  ),
  room: dynamic(() => import('Components/widgets/icons/Room.jsx').then(mod => mod.Room)),

  rooms: dynamic(() => import('Components/widgets/icons/Rooms.jsx').then(mod => mod.Rooms)),

  safe: dynamic(() => import('Components/widgets/icons/Safe.jsx').then(mod => mod.Safe)),

  saferoom: dynamic(() =>
    import('Components/widgets/icons/Saferoom.jsx').then(mod => mod.Saferoom),
  ),

  sailing: dynamic(() => import('Components/widgets/icons/Sailing.jsx').then(mod => mod.Sailing)),

  samc: dynamic(() => import('Components/widgets/icons/Samc.jsx').then(mod => mod.Samc)),

  sanc: dynamic(() => import('Components/widgets/icons/Sanc.jsx').then(mod => mod.Sanc)),

  sandglass: dynamic(() =>
    import('Components/widgets/icons/Sandglass.jsx').then(mod => mod.Sandglass),
  ),

  saoc: dynamic(() => import('Components/widgets/icons/Saoc.jsx').then(mod => mod.Saoc)),

  sayc: dynamic(() => import('Components/widgets/icons/Sayc.jsx').then(mod => mod.Sayc)),

  schc: dynamic(() => import('Components/widgets/icons/Schc.jsx').then(mod => mod.Schc)),

  sea_side: dynamic(() => import('Components/widgets/icons/SeaSide.jsx').then(mod => mod.SeaSide)),

  searchGlass: dynamic(() =>
    import('Components/widgets/icons/SearchGlass.jsx').then(mod => mod.SearchGlass),
  ),

  seaview: dynamic(() => import('Components/widgets/icons/Seaview.jsx').then(mod => mod.Seaview)),

  secureKey: dynamic(() =>
    import('Components/widgets/icons/SecureKey.jsx').then(mod => mod.SecureKey),
  ),

  select: dynamic(() => import('Components/widgets/icons/Select.jsx').then(mod => mod.Select)),

  selectUp: dynamic(() =>
    import('Components/widgets/icons/SelectUp.jsx').then(mod => mod.SelectUp),
  ),

  separate: dynamic(() =>
    import('Components/widgets/icons/Separate.jsx').then(mod => mod.Separate),
  ),

  separate3: dynamic(() =>
    import('Components/widgets/icons/Separate3.jsx').then(mod => mod.Separate3),
  ),

  separated_buildings: dynamic(() =>
    import('Components/widgets/icons/SeparatedBuildings.jsx').then(mod => mod.SeparatedBuildings),
  ),

  shared_room: dynamic(() =>
    import('Components/widgets/icons/SharedRoom.jsx').then(mod => mod.SharedRoom),
  ),

  separatedtoilets: dynamic(() =>
    import('Components/widgets/icons/Separatedtoilets.jsx').then(mod => mod.Separatedtoilets),
  ),
  settings: dynamic(() =>
    import('Components/widgets/icons/Settings.jsx').then(mod => mod.Settings),
  ),

  seyc: dynamic(() => import('Components/widgets/icons/Seyc.jsx').then(mod => mod.Seyc)),

  shampoo: dynamic(() => import('Components/widgets/icons/Shampoo.jsx').then(mod => mod.Shampoo)),

  share: dynamic(() => import('Components/widgets/icons/Share.jsx').then(mod => mod.Share)),

  share_link: dynamic(() =>
    import('Components/widgets/icons/ShareLink.jsx').then(mod => mod.ShareLink),
  ),

  share_messenger: dynamic(() =>
    import('Components/widgets/icons/ShareMessenger.jsx').then(mod => mod.ShareMessenger),
  ),

  share_sms: dynamic(() =>
    import('Components/widgets/icons/ShareSms.jsx').then(mod => mod.ShareSms),
  ),

  share_whatsapp: dynamic(() =>
    import('Components/widgets/icons/ShareWhatsapp.jsx').then(mod => mod.ShareWhatsapp),
  ),

  sheets: dynamic(() => import('Components/widgets/icons/Sheets.jsx').then(mod => mod.Sheets)),

  shower: dynamic(() => import('Components/widgets/icons/Shower.jsx').then(mod => mod.Shower)),

  showerbathtub: dynamic(() =>
    import('Components/widgets/icons/Showerbathtub.jsx').then(mod => mod.Showerbathtub),
  ),

  showerdualwashbasin: dynamic(() =>
    import('Components/widgets/icons/Showerdualwashbasin.jsx').then(mod => mod.Showerdualwashbasin),
  ),

  showertoilets: dynamic(() =>
    import('Components/widgets/icons/Showertoilets.jsx').then(mod => mod.Showertoilets),
  ),

  showerwashbasin: dynamic(() =>
    import('Components/widgets/icons/Showerwashbasin.jsx').then(mod => mod.Showerwashbasin),
  ),

  shuttleBus: dynamic(() =>
    import('Components/widgets/icons/ShuttleBus.jsx').then(mod => mod.ShuttleBus),
  ),

  sibc: dynamic(() => import('Components/widgets/icons/Sibc.jsx').then(mod => mod.Sibc)),

  signout: dynamic(() => import('Components/widgets/icons/Signout.jsx').then(mod => mod.Signout)),

  single: dynamic(() => import('Components/widgets/icons/Single.jsx').then(mod => mod.Single)),

  sink: dynamic(() => import('Components/widgets/icons/Sink.jsx').then(mod => mod.Sink)),

  size: dynamic(() => import('Components/widgets/icons/Size.jsx').then(mod => mod.Size)),

  'ski-resort': dynamic(() =>
    import('Components/widgets/icons/SkiResort.jsx').then(mod => mod.SkiResort),
  ),

  ski: dynamic(() => import('Components/widgets/icons/Ski.jsx').then(mod => mod.Ski)),

  skiAndPoles: dynamic(() =>
    import('Components/widgets/icons/SkiAndPoles.jsx').then(mod => mod.SkiAndPoles),
  ),

  skiEquipments: dynamic(() =>
    import('Components/widgets/icons/SkiEquipments.jsx').then(mod => mod.SkiEquipments),
  ),

  ski_in_out: dynamic(() =>
    import('Components/widgets/icons/SkiInOut.jsx').then(mod => mod.SkiInOut),
  ),

  skilocker: dynamic(() =>
    import('Components/widgets/icons/Skilocker.jsx').then(mod => mod.Skilocker),
  ),

  skimMilk: dynamic(() =>
    import('Components/widgets/icons/SkimMilk.jsx').then(mod => mod.SkimMilk),
  ),

  skinjay: dynamic(() => import('Components/widgets/icons/Skinjay.jsx').then(mod => mod.Skinjay)),

  skiRoom: dynamic(() => import('Components/widgets/icons/SkiRoom.jsx').then(mod => mod.SkiRoom)),

  slippers: dynamic(() =>
    import('Components/widgets/icons/Slippers.jsx').then(mod => mod.Slippers),
  ),

  'slopes-view': dynamic(() =>
    import('Components/widgets/icons/SlopesView.jsx').then(mod => mod.SlopesView),
  ),
  smallCircleCheck: dynamic(() =>
    import('Components/widgets/icons/SmallCircleCheck.jsx').then(mod => mod.SmallCircleCheck),
  ),

  smallWarning: dynamic(() =>
    import('Components/widgets/icons/SmallWarning.jsx').then(mod => mod.SmallWarning),
  ),

  smallCheck: dynamic(() =>
    import('Components/widgets/icons/SmallCheck.jsx').then(mod => mod.SmallCheck),
  ),
  smallCross: dynamic(() =>
    import('Components/widgets/icons/SmallCross.jsx').then(mod => mod.SmallCross),
  ),

  smrc: dynamic(() => import('Components/widgets/icons/Smrc.jsx').then(mod => mod.Smrc)),

  snacks: dynamic(() => import('Components/widgets/icons/Snacks.jsx').then(mod => mod.Snacks)),

  snorkelling: dynamic(() =>
    import('Components/widgets/icons/Snorkelling.jsx').then(mod => mod.Snorkelling),
  ),

  snowboard: dynamic(() =>
    import('Components/widgets/icons/Snowboard.jsx').then(mod => mod.Snowboard),
  ),

  snowboardSkin: dynamic(() =>
    import('Components/widgets/icons/SnowboardSkin.jsx').then(mod => mod.SnowboardSkin),
  ),

  soap: dynamic(() => import('Components/widgets/icons/Soap.jsx').then(mod => mod.Soap)),

  soapDispenser: dynamic(() =>
    import('Components/widgets/icons/SoapDispenser.jsx').then(mod => mod.SoapDispenser),
  ),

  solution: dynamic(() =>
    import('Components/widgets/icons/Solution.jsx').then(mod => mod.Solution),
  ),
  spa: dynamic(() => import('Components/widgets/icons/Spa.jsx').then(mod => mod.Spa)),
  spaMask: dynamic(() => import('Components/widgets/icons/SpaMask.jsx').then(mod => mod.SpaMask)),

  specialOffers: dynamic(() =>
    import('Components/widgets/icons/SpecialOffers.jsx').then(mod => mod.SpecialOffers),
  ),

  spoon: dynamic(() => import('Components/widgets/icons/Spoon.jsx').then(mod => mod.Spoon)),

  sport: dynamic(() => import('Components/widgets/icons/Sport.jsx').then(mod => mod.Sport)),

  sport_school: dynamic(() =>
    import('Components/widgets/icons/SportSchool.jsx').then(mod => mod.SportSchool),
  ),

  stand_up_paddle: dynamic(() =>
    import('Components/widgets/icons/StandUpPaddle.jsx').then(mod => mod.StandUpPaddle),
  ),

  StandaloneMagnifyingGlass: dynamic(() =>
    import('Components/widgets/icons/StandaloneMagnifyingGlass.jsx').then(
      mod => mod.StandaloneMagnifyingGlass,
    ),
  ),

  starlist: dynamic(() =>
    import('Components/widgets/icons/Starlist.jsx').then(mod => mod.Starlist),
  ),

  stereo: dynamic(() => import('Components/widgets/icons/Stereo.jsx').then(mod => mod.Stereo)),

  sterilizer: dynamic(() =>
    import('Components/widgets/icons/Sterilizer.jsx').then(mod => mod.Sterilizer),
  ),

  stInsurance: dynamic(() =>
    import('Components/widgets/icons/SafeTogetherInsurance.jsx').then(mod => mod.Insurance),
  ),

  stopMarker: dynamic(() =>
    import('Components/widgets/icons/StopMarker.jsx').then(mod => mod.StopMarker),
  ),

  storeLocator: dynamic(() =>
    import('Components/widgets/icons/StoreLocator.jsx').then(mod => mod.StoreLocator),
  ),

  straightCheck: dynamic(() =>
    import('Components/widgets/icons/StraightCheck.jsx').then(mod => mod.StraightCheck),
  ),

  stroller: dynamic(() =>
    import('Components/widgets/icons/Stroller.jsx').then(mod => mod.Stroller),
  ),

  stSoap: dynamic(() =>
    import('Components/widgets/icons/safeTogetherSoap.jsx').then(mod => mod.Soap),
  ),

  suite: dynamic(() => import('Components/widgets/icons/Suite.jsx').then(mod => mod.Suite)),

  summary: dynamic(() => import('Components/widgets/icons/Summary.jsx').then(mod => mod.Summary)),

  surf: dynamic(() => import('Components/widgets/icons/Surf.jsx').then(mod => mod.Surf)),

  swim: dynamic(() => import('Components/widgets/icons/Swim.jsx').then(mod => mod.Swim)),

  swimmingpool: dynamic(() =>
    import('Components/widgets/icons/Swimmingpool.jsx').then(mod => mod.Swimmingpool),
  ),

  'table-tennis': dynamic(() =>
    import('Components/widgets/icons/TableTennis.jsx').then(mod => mod.TableTennis),
  ),
  table: dynamic(() => import('Components/widgets/icons/Table.jsx').then(mod => mod.Table)),

  takeOff: dynamic(() => import('Components/widgets/icons/TakeOff.jsx').then(mod => mod.TakeOff)),

  television: dynamic(() =>
    import('Components/widgets/icons/Television.jsx').then(mod => mod.Television),
  ),

  temperature: dynamic(() =>
    import('Components/widgets/icons/Temperature.jsx').then(mod => mod.Temperature),
  ),

  tennis: dynamic(() => import('Components/widgets/icons/Tennis.jsx').then(mod => mod.Tennis)),

  terrace: dynamic(() => import('Components/widgets/icons/Terrace.jsx').then(mod => mod.Terrace)),
  tomc: dynamic(() => import('Components/widgets/icons/Tomc.jsx').then(mod => mod.Tomc)),

  tooltip: dynamic(() => import('Components/widgets/icons/Tooltip.jsx').then(mod => mod.Tooltip)),

  toweldryer: dynamic(() =>
    import('Components/widgets/icons/Toweldryer.jsx').then(mod => mod.Toweldryer),
  ),

  trac: dynamic(() => import('Components/widgets/icons/Trac.jsx').then(mod => mod.Trac)),

  'train-transport': dynamic(() =>
    import('Components/widgets/icons/TrainTransport.jsx').then(mod => mod.TrainTransport),
  ),
  transfer: dynamic(() =>
    import('Components/widgets/icons/Transfer.jsx').then(mod => mod.Transfer),
  ),

  transport: dynamic(() =>
    import('Components/widgets/icons/Transport.jsx').then(mod => mod.Transport),
  ),

  trapeze: dynamic(() => import('Components/widgets/icons/Trapeze.jsx').then(mod => mod.Trapeze)),

  trashCan: dynamic(() =>
    import('Components/widgets/icons/TrashCan.jsx').then(mod => mod.TrashCan),
  ),

  treetop_adventure: dynamic(() =>
    import('Components/widgets/icons/TreetopAdventure.jsx').then(mod => mod.TreetopAdventure),
  ),

  trident: dynamic(() => import('Components/widgets/icons/Trident1.jsx').then(mod => mod.Trident1)),

  trident1: dynamic(() =>
    import('Components/widgets/icons/Trident1.jsx').then(mod => mod.Trident1),
  ),

  trident2: dynamic(() =>
    import('Components/widgets/icons/Trident2.jsx').then(mod => mod.Trident2),
  ),

  trident3: dynamic(() =>
    import('Components/widgets/icons/Trident3.jsx').then(mod => mod.Trident3),
  ),

  trident4: dynamic(() =>
    import('Components/widgets/icons/Trident4.jsx').then(mod => mod.Trident4),
  ),

  trident45: dynamic(() =>
    import('Components/widgets/icons/Trident45.jsx').then(mod => mod.Trident45),
  ),

  trident5: dynamic(() =>
    import('Components/widgets/icons/Trident5.jsx').then(mod => mod.Trident5),
  ),

  trident6: dynamic(() =>
    import('Components/widgets/icons/Trident6.jsx').then(mod => mod.Trident6),
  ),

  tridentjoyview: dynamic(() =>
    import('Components/widgets/icons/Tridentjoyview.jsx').then(mod => mod.Tridentjoyview),
  ),

  turc: dynamic(() => import('Components/widgets/icons/Turc.jsx').then(mod => mod.Turc)),

  tvcc: dynamic(() => import('Components/widgets/icons/Tvcc.jsx').then(mod => mod.Tvcc)),

  umbrella: dynamic(() =>
    import('Components/widgets/icons/Umbrella.jsx').then(mod => mod.Umbrella),
  ),

  urgentisation: dynamic(() =>
    import('Components/widgets/icons/Urgentisation.jsx').then(mod => mod.Urgentisation),
  ),

  usb: dynamic(() => import('Components/widgets/icons/Usb.jsx').then(mod => mod.Usb)),

  user: dynamic(() => import('Components/widgets/icons/User.jsx').then(mod => mod.User)),

  users: dynamic(() => import('Components/widgets/icons/Users.jsx').then(mod => mod.Users)),

  'valley-view': dynamic(() =>
    import('Components/widgets/icons/ValleyView.jsx').then(mod => mod.ValleyView),
  ),
  ventilatedlocker: dynamic(() =>
    import('Components/widgets/icons/Ventilatedlocker.jsx').then(mod => mod.Ventilatedlocker),
  ),

  verc: dynamic(() => import('Components/widgets/icons/Verc.jsx').then(mod => mod.Verc)),

  videos: dynamic(() => import('Components/widgets/icons/Videos.jsx').then(mod => mod.Videos)),

  videos360: dynamic(() =>
    import('Components/widgets/icons/Videos360.jsx').then(mod => mod.Videos360),
  ),

  visc: dynamic(() => import('Components/widgets/icons/Visc.jsx').then(mod => mod.Visc)),

  vlpc: dynamic(() => import('Components/widgets/icons/Vlpc.jsx').then(mod => mod.Vlpc)),

  vmoc: dynamic(() => import('Components/widgets/icons/Vmoc.jsx').then(mod => mod.Vmoc)),

  vmov: dynamic(() => import('Components/widgets/icons/Vmov.jsx').then(mod => mod.Vmov)),

  volleyball: dynamic(() =>
    import('Components/widgets/icons/Volleyball.jsx').then(mod => mod.Volleyball),
  ),

  vsoc: dynamic(() => import('Components/widgets/icons/Vsoc.jsx').then(mod => mod.Vsoc)),

  vthc: dynamic(() => import('Components/widgets/icons/Vthc.jsx').then(mod => mod.Vthc)),

  vtt: dynamic(() => import('Components/widgets/icons/Vtt.jsx').then(mod => mod.Vtt)),

  walking: dynamic(() => import('Components/widgets/icons/Walking.jsx').then(mod => mod.Walking)),

  warning: dynamic(() => import('Components/widgets/icons/Warning.jsx').then(mod => mod.Warning)),

  washingmachine: dynamic(() =>
    import('Components/widgets/icons/Washingmachine.jsx').then(mod => mod.Washingmachine),
  ),

  wash: dynamic(() => import('Components/widgets/icons/Wash.jsx').then(mod => mod.Wash)),

  waterbottle: dynamic(() =>
    import('Components/widgets/icons/Waterbottle.jsx').then(mod => mod.Waterbottle),
  ),

  waterski: dynamic(() =>
    import('Components/widgets/icons/Waterski.jsx').then(mod => mod.Waterski),
  ),

  weight: dynamic(() => import('Components/widgets/icons/Weight.jsx').then(mod => mod.Weight)),

  welcomegift: dynamic(() =>
    import('Components/widgets/icons/Welcomegift.jsx').then(mod => mod.Welcomegift),
  ),

  'well-being': dynamic(() =>
    import('Components/widgets/icons/WellBeing.jsx').then(mod => mod.WellBeing),
  ),
  wholeMilk: dynamic(() =>
    import('Components/widgets/icons/WholeMilk.jsx').then(mod => mod.WholeMilk),
  ),
  wibilongIcon: dynamic(() =>
    import('Components/widgets/icons/WibilongIcon.jsx').then(mod => mod.WibilongIcon),
  ),

  wifi: dynamic(() => import('Components/widgets/icons/Wifi.jsx').then(mod => mod.Wifi)),

  windsurfing: dynamic(() =>
    import('Components/widgets/icons/Windsurfing.jsx').then(mod => mod.Windsurfing),
  ),

  wineCellar: dynamic(() =>
    import('Components/widgets/icons/WineCellar.jsx').then(mod => mod.WineCellar),
  ),

  yabc: dynamic(() => import('Components/widgets/icons/Yabc.jsx').then(mod => mod.Yabc)),

  yanj: dynamic(() => import('Components/widgets/icons/Yanj.jsx').then(mod => mod.Yanj)),

  yasc: dynamic(() => import('Components/widgets/icons/Yasc.jsx').then(mod => mod.Yasc)),

  yoga: dynamic(() => import('Components/widgets/icons/Yoga.jsx').then(mod => mod.Yoga)),

  yogamat: dynamic(() => import('Components/widgets/icons/Yogamat.jsx').then(mod => mod.Yogamat)),

  zenzone: dynamic(() => import('Components/widgets/icons/Zenzone.jsx').then(mod => mod.Zenzone)),

  '45': dynamic(() => import('Components/widgets/icons/Svg45.jsx').then(mod => mod.Svg45)),
  '1Stop': dynamic(() => import('Components/widgets/icons/Svg1Stop.jsx').then(mod => mod.Svg1Stop)),
  '2Stops': dynamic(() =>
    import('Components/widgets/icons/Svg2Stops.jsx').then(mod => mod.Svg2Stops),
  ),
  '404': dynamic(() => import('Components/widgets/icons/Svg404.jsx').then(mod => mod.Svg404)),
  winterMountainResorts: dynamic(() =>
    import('Components/widgets/icons/WinterMountainResorts.jsx').then(
      mod => mod.WinterMountainResorts,
    ),
  ),
  wechat: dynamic(() => import('Components/widgets/icons/Wechat.jsx').then(mod => mod.Wechat)),
  whatsapp: dynamic(() =>
    import('Components/widgets/icons/Whatsapp.jsx').then(mod => mod.Whatsapp),
  ),
  ClubMedExclusive: dynamic(() =>
    import('Components/widgets/icons/ClubMedExclusive.jsx').then(mod => mod.ClubMedExclusive),
  ),

  allInclusiveWithShadow: dynamic(() =>
    import('Components/widgets/icons/AllInclusiveWithShadow.jsx').then(
      mod => mod.AllInclusiveWithShadow,
    ),
  ),
  callMeBack: dynamic(() =>
    import('Components/widgets/icons/CallMeBack.jsx').then(mod => mod.CallMeBack),
  ),
  cough: dynamic(() => import('Components/widgets/icons/Cough.jsx').then(mod => mod.Cough)),
  charmprestige: dynamic(() =>
    import('Components/widgets/icons/CharmPrestige.jsx').then(mod => mod.CharmPrestige),
  ),
  circledCheck: dynamic(() =>
    import('Components/widgets/icons/CircledCheck.jsx').then(mod => mod.CircledCheck),
  ),
  clubmedAllInclusiveLargeChina: dynamic(() =>
    import('Components/widgets/icons/ClubmedAllInclusiveLargeChina.jsx').then(
      mod => mod.ClubmedAllInclusiveLargeChina,
    ),
  ),
  clubmedAllInclusiveSmallChina: dynamic(() =>
    import('Components/widgets/icons/ClubmedAllInclusiveSmallChina.jsx').then(
      mod => mod.ClubmedAllInclusiveSmallChina,
    ),
  ),
  clubmedcollectivites: dynamic(() =>
    import('Components/widgets/icons/ClubmedCollectivites.jsx').then(
      mod => mod.ClubmedCollectivites,
    ),
  ),
  clubmedGreatMember: dynamic(() =>
    import('Components/widgets/icons/ClubMedGreatMember.jsx').then(mod => mod.ClubMedGreatMember),
  ),
  clubmedLogoGreatMembersTrade: dynamic(() =>
    import('Components/widgets/icons/ClubmedLogoGreatMembersTrade.jsx').then(
      mod => mod.ClubmedLogoGreatMembersTrade,
    ),
  ),
  dmd_standard: dynamic(() =>
    import('Components/widgets/icons/DmdStandard.jsx').then(mod => mod.DmdStandard),
  ),
  dollar: dynamic(() => import('Components/widgets/icons/Dollar.jsx').then(mod => mod.Dollar)),
  douban: dynamic(() => import('Components/widgets/icons/Douban.jsx').then(mod => mod.Douban)),
  earlySun: dynamic(() =>
    import('Components/widgets/icons/EarlySun.jsx').then(mod => mod.EarlySun),
  ),
  easyArrival: dynamic(() =>
    import('Components/widgets/icons/EasyArrival.jsx').then(mod => mod.EasyArrival),
  ),
  faq: dynamic(() => import('Components/widgets/icons/Faq.jsx').then(mod => mod.Faq)),
  flexibleWithShadow: dynamic(() =>
    import('Components/widgets/icons/FlexibleWithShadow.jsx').then(mod => mod.FlexibleWithShadow),
  ),
  flickr: dynamic(() => import('Components/widgets/icons/Flickr.jsx').then(mod => mod.Flickr)),
  garden: dynamic(() => import('Components/widgets/icons/Garden.jsx').then(mod => mod.Garden)),
  gentilbot: dynamic(() =>
    import('Components/widgets/icons/GentilBot.jsx').then(mod => mod.GentilBot),
  ),
  googleplus: dynamic(() =>
    import('Components/widgets/icons/Googleplus.jsx').then(mod => mod.Googleplus),
  ),
  GreatMembersGold: dynamic(() =>
    import('Components/widgets/icons/GreatMembersGold.jsx').then(mod => mod.GreatMembersGold),
  ),
  GreatMembersPlatinum: dynamic(() =>
    import('Components/widgets/icons/GreatMembersPlatinum.jsx').then(
      mod => mod.GreatMembersPlatinum,
    ),
  ),
  GreatMembersSilver: dynamic(() =>
    import('Components/widgets/icons/GreatMembersSilver.jsx').then(mod => mod.GreatMembersSilver),
  ),
  GreatMembersTurquoise: dynamic(() =>
    import('Components/widgets/icons/GreatMembersTurquoise.jsx').then(
      mod => mod.GreatMembersTurquoise,
    ),
  ),
  GreatMembersWithShadow: dynamic(() =>
    import('Components/widgets/icons/GreatMembersWithShadow.jsx').then(
      mod => mod.GreatMembersWithShadow,
    ),
  ),
  introTrident: dynamic(() =>
    import('Components/widgets/icons/IntroTrident.jsx').then(mod => mod.IntroTrident),
  ),
  kids: dynamic(() => import('Components/widgets/icons/Kids.jsx').then(mod => mod.Kids)),
  lateSun: dynamic(() => import('Components/widgets/icons/LateSun.jsx').then(mod => mod.LateSun)),
  luggagetransport: dynamic(() =>
    import('Components/widgets/icons/LuggageTransport.jsx').then(mod => mod.LuggageTransport),
  ),
  mailReverse: dynamic(() =>
    import('Components/widgets/icons/MailReverse.jsx').then(mod => mod.MailReverse),
  ),
  microphone: dynamic(() =>
    import('Components/widgets/icons/Microphone.jsx').then(mod => mod.Microphone),
  ),
  mixable: dynamic(() => import('Components/widgets/icons/Mixable.jsx').then(mod => mod.Mixable)),
  mobileapp: dynamic(() =>
    import('Components/widgets/icons/Mobileapp.jsx').then(mod => mod.Mobileapp),
  ),
  moon: dynamic(() => import('Components/widgets/icons/Moon.jsx').then(mod => mod.Moon)),
  overflowingpool: dynamic(() =>
    import('Components/widgets/icons/Overflowingpool.jsx').then(mod => mod.Overflowingpool),
  ),
  peoplebaby: dynamic(() =>
    import('Components/widgets/icons/PeopleBaby.jsx').then(mod => mod.PeopleBaby),
  ),
  pinroom: dynamic(() => import('Components/widgets/icons/PinRoom.jsx').then(mod => mod.PinRoom)),
  pinroomhighlight: dynamic(() =>
    import('Components/widgets/icons/PinRoomHighlight.jsx').then(mod => mod.PinRoomHighlight),
  ),
  reducedCapacity: dynamic(() =>
    import('Components/widgets/icons/ReducedCapacity.jsx').then(mod => mod.ReducedCapacity),
  ),
  repartitionAdultExp: dynamic(() =>
    import('Components/widgets/icons/RepartitionAdultExp.jsx').then(mod => mod.RepartitionAdultExp),
  ),
  repartitionBabyExp: dynamic(() =>
    import('Components/widgets/icons/RepartitionBabyExp.jsx').then(mod => mod.RepartitionBabyExp),
  ),
  repartitionChildExp: dynamic(() =>
    import('Components/widgets/icons/RepartitionChildExp.jsx').then(mod => mod.RepartitionChildExp),
  ),
  resortHouse: dynamic(() =>
    import('Components/widgets/icons/ResortHouse.jsx').then(mod => mod.ResortHouse),
  ),
  resortsAdults: dynamic(() =>
    import('Components/widgets/icons/ResortsAdults.jsx').then(mod => mod.ResortsAdults),
  ),
  sea: dynamic(() => import('Components/widgets/icons/Sea.jsx').then(mod => mod.Sea)),
  social: dynamic(() => import('Components/widgets/icons/Social.jsx').then(mod => mod.Social)),
  socialDistancing: dynamic(() =>
    import('Components/widgets/icons/SocialDistancing.jsx').then(mod => mod.SocialDistancing),
  ),
  sponsorship: dynamic(() =>
    import('Components/widgets/icons/Sponsorship.jsx').then(mod => mod.Sponsorship),
  ),
  sport_leisure_and_relaxation: dynamic(() =>
    import('Components/widgets/icons/SportLeisureAndRelaxation.jsx').then(
      mod => mod.SportLeisureAndRelaxation,
    ),
  ),
  sun: dynamic(() => import('Components/widgets/icons/Sun.jsx').then(mod => mod.Sun)),
  train: dynamic(() => import('Components/widgets/icons/Train.jsx').then(mod => mod.Train)),
  usertalk: dynamic(() =>
    import('Components/widgets/icons/UserTalk.jsx').then(mod => mod.UserTalk),
  ),
  vine: dynamic(() => import('Components/widgets/icons/Vine.jsx').then(mod => mod.Vine)),
  vkontakte: dynamic(() =>
    import('Components/widgets/icons/Vkontakte.jsx').then(mod => mod.Vkontakte),
  ),
  wechatPayment: dynamic(() =>
    import('Components/widgets/icons/WechatPayment.jsx').then(mod => mod.WechatPayment),
  ),
  weibo: dynamic(() => import('Components/widgets/icons/Weibo.jsx').then(mod => mod.Weibo)),
  wellness: dynamic(() =>
    import('Components/widgets/icons/Wellness.jsx').then(mod => mod.Wellness),
  ),
  wenc: dynamic(() => import('Components/widgets/icons/Wenc.jsx').then(mod => mod.Wenc)),
  youtube: dynamic(() => import('Components/widgets/icons/Youtube.jsx').then(mod => mod.Youtube)),
};

export const getLoader = (iconName: IconName) => {
  // iconName is valid
  if (loaders[iconName]) {
    return loaders[iconName];
  }

  // handle iconName as a key of the ICONS enum
  if (loaders[ICONS[iconName]]) {
    return loaders[ICONS[iconName]];
  }

  // iconName has not a valid case
  if (loaders[iconName.toLowerCase()]) {
    return loaders[iconName.toLowerCase()];
  }

  // no icon found
  return null;
};
